import request from "@/utils/request";

// 获取开放道路列表
export function getRoadsPageList(data) {
  return request({
    url: "/open/roads/page",
    method: "post",
    data: data
  });
}

// 获取开放道路信息
export function getRoadsInfo(roadId) {
  return request({
    url: "/open/roads/info?roadId=" + roadId,
    method: "get",
  });
}